// extracted by mini-css-extract-plugin
export var tooltip = "ToolTip-module--tooltip--20c6f";